<div class="related-resource-card">
    <div class="related-resource-card-title">
        {{ title }}
    </div>
    <div class="related-resource-card-status" *ngIf="parentInput().relatedResourceInfo">
        <div>
            {{ "inventoryResourcePage.relatedResourceCardStatusTitle" | labelsProvider }}
        </div>
        <app-status-label [statusLabel]="parentInput().relatedResourceInfo?.resourceStatus ?? ''"></app-status-label>
    </div>
    <app-card-fields [cardFields]="fields"> </app-card-fields>

    <div *ngIf="additionalInfoFields.length > 0" class="additional-info-card">
        <app-accordion
            class="related-resource-card-title"
            accordionTitle="inventoryResourcePage.additionalInfoCardTitle"
            [boldTitle]="true"
            [withLabelPipe]="true"
            [expanded]="relationBodyExpansionState"
            (accordionExpansionEvent)="updateRelationBodyAccordionExpansionState($event)">
            <app-card-fields [cardFields]="additionalInfoFields"></app-card-fields>
        </app-accordion>
    </div>

    <app-anchor-link
        [navigation]="{
            commands: [],
            queryParamsHandling: 'merge',
            queryParams: {
                integration: parentInput().integrationId,
                resource: parentInput().relatedResourceInfo!.resourceId,
                violation: null,
            },
        }">
        {{ "inventoryResourcePage.relatedViolationCardExploreResourceLink" | labelsProvider }}
        <img src="assets/images/arrows/empty-arrow-right.svg" class="explore-resource-link__icon" />
    </app-anchor-link>

    <div *ngIf="!parentInput().relatedResourceInfo" class="related-resource-card-broken-relation">
        <div>
            {{ "inventoryResourcePage.brokenRelationDisclaimer" | labelsProvider }}
        </div>
        <app-anchor-link navigation="/app/support">
            {{ "inventoryResourcePage.contactSupport" | labelsProvider }}
        </app-anchor-link>
    </div>
</div>
